"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useSendEvent;

var _useWebChatAPIContext = _interopRequireDefault(require("./internal/useWebChatAPIContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useSendEvent() {
  return (0, _useWebChatAPIContext.default)().sendEvent;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9ob29rcy91c2VTZW5kRXZlbnQudHMiXSwibmFtZXMiOlsidXNlU2VuZEV2ZW50Iiwic2VuZEV2ZW50Il0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUE7Ozs7QUFFZSxTQUFTQSxZQUFULEdBQTREO0FBQ3pFLFNBQU8scUNBQXVCQyxTQUE5QjtBQUNEIiwic291cmNlUm9vdCI6ImNvbXBvbmVudDovLy8iLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgdXNlV2ViQ2hhdEFQSUNvbnRleHQgZnJvbSAnLi9pbnRlcm5hbC91c2VXZWJDaGF0QVBJQ29udGV4dCc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIHVzZVNlbmRFdmVudCgpOiAobmFtZTogc3RyaW5nLCB2YWx1ZTogYW55KSA9PiB2b2lkIHtcbiAgcmV0dXJuIHVzZVdlYkNoYXRBUElDb250ZXh0KCkuc2VuZEV2ZW50O1xufVxuIl19